<div
	class="c-portlet o-block u-width-100p _u-width-100p u-bg-primary c-portlet_box_specs pos-relative daily-metrics-r5 {{currentPageClass}} {{
		sectionclass
	}}"
	style="min-height: 23em"
>
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
		<div class="o-stack__cell primary-color">
			<h5 class="title primary-color">
				{{ sectiontitle }}
				<a
					href="javascript:void(0)"
					class="download_icon"
					*ngIf="downloadConfiguration?.enableDownload && hasData"
					(click)="downloadCSV($event)"
					target="_blank"
					><img src="../../../../../assets/images/Download_Icon.svg"
				/></a>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content cox_r5_portlet_content">
		<div style="width: 100%; height: 100%">
			<div class="colorBg" class="graph">
				<div class="wrapper daily_mtrcs">
					<div id="graph-area" #graphArea></div>
				</div>
				<div class="legend-area" *ngIf="!legendDisabled">
					<ul class="legend">
						<li
							class="legend_item primary-color-border"
							[ngClass]="{ item_selected: legendItem.selected }"
							(click)="selectLegendItem(legendItem)"
							*ngFor="let legendItem of filteredLegends"
						>
							<span [innerHTML]="legendItem.displayName" style="display: inline-block; line-height: 15px"></span>
							<i
								*ngIf="legendItem.selected"
								class="fa fa-caret-left"
								[ngStyle]="{ 'font-size': '22px', color: colorPalette.primaryColor }"
							></i
							><i *ngIf="!legendItem.selected" class="space"></i>
						</li>
					</ul>
				</div>
				<div class="clearBoth"></div>
				<div class="date-div">
					{{ dateRange }}
				</div>
			</div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
				<div class="o-stack__cell">
					<h5 class="title primary-color">{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data c-portlet">No Data to Display</div>
		</div>
	</div>
</div>
